import styled from "styled-components";

export const ErrorText = styled.div`
    display: ${(props) => (props.invalidInput ? "block" : "none")};
    color: ${({ theme }) => theme.colors.error[700]};
    height: 20px;
    font-size: 14px;
`;
